export const riskTabIndex = state => state.riskTabIndex
export const isShowVideoPopup = state => state.isShowVideoPopup
export const closeVideoPopup = state => state.closeVideoPopup
export const quickSearchList = state => state.quickSearchList
